<div class="upload-list">
    @for (item of uploads(); track item.id) {
        <div class="upload-list__item" @fadeExit>
            <i class="upload-list__type-icon" [ngClass]="item.isFolder ? 'pi pi-folder' : 'pi pi-file'"></i>
            <span class="upload-list__name" [title]="item.name">{{ item.name }}</span>
            @if (item.isFolder && item.total > 0) {
                <span class="upload-list__progress">{{ item.completed }}/{{ item.total }}</span>
            }
            <span class="upload-list__status">
                @switch (item.status) {
                    @case ('success') {
                        <i class="pi pi-check-circle upload-list__icon-success"></i>
                    }
                    @case ('error') {
                        <i class="pi pi-times-circle upload-list__icon-error"></i>
                    }
                    @case ('uploading') {
                        <i class="pi pi-spin pi-spinner upload-list__icon-uploading"></i>
                    }
                    @case ('scanning') {
                        <i class="pi pi-spin pi-spinner upload-list__icon-scanning" title="Vírusellenőrzés"></i>
                    }
                    @default {
                        <i class="pi pi-clock upload-list__icon-pending"></i>
                    }
                }
            </span>
        </div>
        @if (item.children && item.children.length > 0) {
            @for (child of item.children; track child.id) {
                <div class="upload-list__item" @fadeExit>
                    <i class="upload-list__type-icon pi pi-file"></i>
                    <span class="upload-list__name" [title]="child.name">{{ child.name }}</span>
                    <span class="upload-list__status">
                        @switch (child.status) {
                            @case ('success') {
                                <i class="pi pi-check-circle upload-list__icon-success"></i>
                            }
                            @case ('error') {
                                <i class="pi pi-times-circle upload-list__icon-error"></i>
                            }
                            @case ('uploading') {
                                <i class="pi pi-spin pi-spinner upload-list__icon-uploading"></i>
                            }
                            @case ('scanning') {
                                <i class="pi pi-spin pi-spinner upload-list__icon-scanning" title="Vírusellenőrzés"></i>
                            }
                            @default {
                                <i class="pi pi-clock upload-list__icon-pending"></i>
                            }
                        }
                    </span>
                </div>
            }
        }
    }
</div>
